module.exports = __webpack_public_path__ + "img/link.65c0e9a1.png";